import React from 'react'

function Videos() {
  return (
    <div>
        <hr />
        <div className='mt-10 mb-10' style={{fontSize:'50px'}}>BE INSPIERD</div>
    </div>
  )
}

export default Videos
